import { render, staticRenderFns } from "./BarChartCities.vue?vue&type=template&id=6a93f0d4&"
import script from "./BarChartCities.vue?vue&type=script&lang=js&"
export * from "./BarChartCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports